import CanIdEditorContainer from './CanIdEditorContainer'

export default CanIdEditorContainer
